import React from 'react';
import './TopPlayerIcon.css';

interface TopPlayerIconProps {
  type: 'leader' | 'topGoalContribution' | 'topScorer' | 'topAssister' | 'mostLoyal' | 'leastLoyal';
  size?: number;
}

const TopPlayerIcon: React.FC<TopPlayerIconProps> = ({ type, size = 24 }) => {
  const iconPaths: { [key: string]: string } = {
    leader: '/icons/lider-icon.png.png',
    topGoalContribution: '/icons/gol-katkisi-icon.png',
    topScorer: '/icons/gol-krali-icon.png.png',
    topAssister: '/icons/asist-krali-icon.png.png',
    mostLoyal: '/icons/en-sadik-icon.png.png',
    leastLoyal: '/icons/konserci-icon.png.png',
  };

  return (
    <img 
      src={iconPaths[type]} 
      alt={type} 
      className="top-player-icon-img"
      style={{ width: size, height: size }}
      onError={(e) => {
        // İkon yüklenemezse görünmez yap
        e.currentTarget.style.display = 'none';
      }}
    />
  );
};

export default TopPlayerIcon;


